<template>
	<div class="Dropdown">
		<div class="current-selection"
			v-on:click="showOptions()">
			{{ selectedOptionName }}
		</div>
		<div
			class="options" v-bind:class="{ visible: optionsVisible }"
			tabindex=0 v-on:keydown="optionsKeydown" ref="options">
			<div v-for="option in options" :key="option.key" class="option"
				v-bind:class="{
					keyboardSelected: option.key ===
					keyboardSelectedOptionKey
				}"
				v-on:click="optionClicked(option.key)">
				{{ option.name }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		// Example:
		// options: [
		// 	{ key: 'one', name: 'Option One' },
		// 	{ key: 'two',  name: 'Option Two' },
		// 	{ key: 'three', name: 'Option Three' }
		// ],
		options: {
			type: Array,
			required: false,
			default: function() {
				return []
			}
		},

		initialValue: String
	},

	data() {
		return {
			optionsVisible: false,
			keyboardSelectionIdx: null,
			value: this.initialValue
		}
	},

	computed: {
		selectedOptionName() {
			let selectedOption = this.options.find(option =>
				option.key === this.value)
			return selectedOption ? selectedOption.name : ''
		},

		keyboardSelectedOptionKey() {
			let selectedOption = this.options[this.keyboardSelectionIdx]
			return selectedOption ? selectedOption.key : null
		}
	},

	methods: {
		showOptions() {
			this.optionsVisible = true
			this.keyboardSelectionIdx = this.findIndexForKey(this.value)
			setTimeout(() => {
				this.$refs.options.focus()
				let self = this
				this.$refs.options.addEventListener(
					'blur',
					function blur() {
						self.$refs.options.removeEventListener('blur', blur)
						self.optionsVisible = false
					})
			}, 1)
		},

		optionsKeydown(ev) {
			if (ev.keyCode === 40) {
				this.keyboardSelectionIdx++
				if (this.keyboardSelectionIdx >= this.options.length) {
					this.keyboardSelectionIdx = this.options.length - 1
				}
				ev.preventDefault()
			} else if (ev.keyCode === 38) {
				this.keyboardSelectionIdx--
				if (this.keyboardSelectionIdx < 0) {
					this.keyboardSelectionIdx = 0
				}
				ev.preventDefault()
			} else if (ev.keyCode === 13) {
				this.setValue(this.keyboardSelectedOptionKey)
				this.optionsVisible = false
				ev.preventDefault()
			} else if (ev.keyCode === 27) {
				// Esc
				this.optionsVisible = false
				ev.preventDefault()
			}
		},

		findIndexForKey(key) {
			// IE11 doesn't have findIndex
			for (let i = 0; i < this.options.length; i++) {
				if (this.options[i].key === key) {
					return i
				}
			}

			return 0
		},

		setValue(key) {
			this.value = key
			this.$emit('input', key)
		},

		optionClicked(key) {
			this.setValue(key)
			this.optionsVisible = false
		}
	}
}
</script>

<style lang=stylus scoped>
.Dropdown {
	display: inline-block;
	position: relative;

	color: inherit;
	font-weight: inherit;
}

.Dropdown > .current-selection {
	font-weight: inherit;
	padding-right: 15px;
}

.Dropdown > .current-selection::after {
	position: absolute;
	top: 50%;
	right: 0;

	content: '▼';
	font-size: 8px;

	transform: translateY(-50%);
}

.Dropdown > .options {
	position: absolute;
	top: 0;
	right: 0;

	display: none;
	&.visible {
		display: block;
	}

	&:focus {
		outline: none;
	}

	background: white;
	color: black;
	min-width: 60px;

	box-shadow: 1px 2px 12px 0 rgba(0, 0, 0, 0.16);
	border-radius: 4px;
}

.Dropdown > .options > .option {
	padding: 5px 10px;

	&:not(:first-child) {
		border-top: 1px solid #dadada;
	}

	&:first-child {
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
	}

	&:last-child {
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
	}

	&:hover {
		background: #f9f9f6;
	}

	&.keyboardSelected {
		background: #eee;
	}
}
</style>
